import type { FaqItem } from '../types'

export const faqs: FaqItem[] = [
  {
    id: 'frequency',
    question: {
      en: 'How often should I get my home professionally cleaned?',
      es: '¿Con qué frecuencia debo limpiar mi casa profesionalmente?',
    },
    answer: {
      en: 'Most customers start with a one-time deep clean, then schedule bi-weekly or monthly maintenance cleaning to keep the home in that condition.',
      es: 'La mayoría empieza con una limpieza profunda inicial y luego agenda mantenimiento cada dos semanas o mensual para conservar ese resultado.',
    },
  },
  {
    id: 'products',
    question: {
      en: 'Are your cleaning products safe for my family?',
      es: '¿Sus productos de limpieza son seguros para mi familia?',
    },
    answer: {
      en: 'Yes. We use eco-friendly, pet-safe and child-safe products by default, and we can switch to fragrance-free options on request.',
      es: 'Sí. Usamos productos ecológicos, seguros para mascotas y niños, y podemos cambiar a opciones sin fragancia si lo solicita.',
    },
  },
  {
    id: 'sameday',
    question: { en: 'Do you offer same-day service?', es: '¿Ofrecen servicio el mismo día?' },
    answer: {
      en: 'Yes, same-day service is available based on crew availability. Call or text us and we will confirm your window right away.',
      es: 'Sí, el servicio el mismo día está disponible según la disponibilidad del equipo. Llame o escriba y confirmamos su horario de inmediato.',
    },
  },
  {
    id: 'booking',
    question: {
      en: 'How do I book a cleaning appointment?',
      es: '¿Cómo reservo una cita de limpieza?',
    },
    answer: {
      en: 'Call, text, message us on WhatsApp, or submit the booking form on this page — whichever is easiest for you.',
      es: 'Llame, envíe un mensaje de texto, escríbanos por WhatsApp o llene el formulario de esta página, como le sea más cómodo.',
    },
  },
  {
    id: 'insured',
    question: { en: 'Are you insured and bonded?', es: '¿Están asegurados y afianzados?' },
    answer: {
      en: 'Yes — 3D Cleaning Services is fully licensed, insured and bonded, and every team member is background checked.',
      es: 'Sí: 3D Cleaning Services cuenta con licencia, seguro y fianza, y cada miembro del equipo está verificado.',
    },
  },
  {
    id: 'supplies',
    question: {
      en: 'Do you provide supplies or should I?',
      es: '¿Ustedes traen los productos o los debo proporcionar yo?',
    },
    answer: {
      en: 'We bring all supplies and professional equipment. If you prefer we use your own products, just let us know beforehand.',
      es: 'Nosotros llevamos todos los productos y el equipo profesional. Si prefiere que usemos los suyos, avísenos con anticipación.',
    },
  },
  {
    id: 'deepclean',
    question: { en: "What's included in a deep cleaning?", es: '¿Qué incluye una limpieza profunda?' },
    answer: {
      en: 'Comprehensive cleaning of every room: baseboards, walls, doors, ceiling fans, vents, appliances inside and out, bathrooms, kitchen, and all floors scrubbed.',
      es: 'Limpieza integral de cada habitación: zócalos, paredes, puertas, ventiladores, rejillas, electrodomésticos por dentro y fuera, baños, cocina y fregado de todos los pisos.',
    },
  },
  {
    id: 'schedule',
    question: { en: 'Can you work with my schedule?', es: '¿Se pueden adaptar a mi horario?' },
    answer: {
      en: 'Absolutely. We are flexible with scheduling, including early mornings and Saturdays, and Sundays by appointment.',
      es: 'Por supuesto. Somos flexibles con los horarios, incluyendo temprano por la mañana y sábados, y domingos con cita.',
    },
  },
]
